module.exports = __webpack_public_path__ + "img/blade_mail.3768962a.png";